import React, { Fragment, Children, PureComponent } from 'react'
import cn from 'classnames'
import PaneGroup from 'components/PaneGroup'
import AppNotices from 'components/AppNotices'
import RightSidebarToggler from 'components/App/DesktopView/Layout/RightSidebar/Toggler'
import { WithGlobalNav } from 'components/App/DesktopView/Layout/GlobalNav'
import OverlayBackground from 'components/App/DesktopView/Layout/LayoutSwitcher/ModernView/OverlayBackground'
import HotkeysModal from 'components/App/DesktopView/Layout/HotkeysModal'
import themeVars from 'ui_theme/site/globals/site.variables'
import PropTypes from 'prop-types'
import Sidebar from '../Sidebar'
import styles from './styles.less'

// Kevin R (2020-07-13)
// TODO: Refactor column layout and correctly abstract the "Layout Component" vs "Layout Implementation" parts
// Our current layouts are called "3 and 4 column" layouts, but in reality there is actually 4 and 5 columns on the page
// This is due to the fact that we're assuming the very left had navigation is actually part of the left hand menu
// which is mostly true, but not always true. We should have a component that allows us to create X number of columns
// and then use that column to implement components which has 3,4,5...X columns based on a configuration.
// My honest opinoin is that we need to drop Column layout and replace it with something like this https://github.com/STRML/react-grid-layout
// and then create the following layouts
// 3 column: global nav, folders, conversation list
// 4 column: global nav, folders, conversation view, customer data
// 5 column: global nav, folders, conversation list, conversation view,  customer data
export default class ColumnLayout extends PureComponent {
  static propTypes = {
    toggleRightSidebar: PropTypes.func,
    mediaQuery: PropTypes.string,
    isRightSidebarCollapsed: PropTypes.bool,
  }
  static defaultProps = {
    // eslint-disable-next-line no-console
    toggleRightSidebar: () => console.log('toggleRightSidebar not provided'),
    mediaQuery: null,
    isRightSidebarCollapsed: false,
  }

  rightSidebarWrapper = React.forwardRef((props, ref) => {
    const { isRightSidebarCollapsed } = this.props
    const { overlay, ...rest } = props
    return (
      <div
        {...rest}
        ref={ref}
        style={{
          ...props.style,
          ...(isRightSidebarCollapsed && {
            marginLeft: -props.style.width,
            transform: 'translateX(100%)',
          }),
          ...(overlay && {
            width: 320,
            flexGrow: 0,
            flexShrink: 0,
            marginLeft: -320,
            transform: !isRightSidebarCollapsed ? null : 'translateX(100%)',
            zIndex: 98,
          }),
        }}
        className={cn(
          props.className,
          styles.rightSidebarWrapper,
          'hidden-in-print'
        )}
      />
    )
  })

  noPrintWrapper = React.forwardRef((props, ref) => {
    const { overlay, ...rest } = props
    return (
      <div
        {...rest}
        ref={ref}
        className={cn(props.className, 'hidden-in-print')}
      />
    )
  })

  threeColumnWrappers = [null, this.rightSidebarWrapper]
  fourColumnWrappers = [this.noPrintWrapper, null, this.rightSidebarWrapper]

  render() {
    const {
      children,
      panelWidths,
      panelUpdateCallback,
      toggleRightSidebar,
      mediaQuery,
      columnConfig,
      isRightSidebarCollapsed,
      breakpoints,
    } = this.props

    const componentWrappers =
      columnConfig.length > 2
        ? this.fourColumnWrappers
        : this.threeColumnWrappers
    const isUnder1200 = mediaQuery === '(max-width: 1199px)'
    return (
      <Fragment>
        <WithGlobalNav
          active="Live Chat"
          topContent={<AppNotices />}
          leftSidebarBg={themeVars.darkGroovy}
          leftSidebar={<Sidebar />}
        >
          {columnConfig.includes(2) && <RightSidebarToggler />}
          <PaneGroup
            className={styles.chatPaneGroup}
            spacing={0}
            panelWidths={panelWidths}
            onUpdate={panelUpdateCallback}
            ComponentWrappers={componentWrappers}
            breakpoints={breakpoints}
          >
            {Children.map(children, (child, i) => {
              if (columnConfig.includes(i)) return child
              return null
            })}
          </PaneGroup>
          <OverlayBackground
            onClick={toggleRightSidebar}
            visible={isUnder1200 && !isRightSidebarCollapsed}
          />
        </WithGlobalNav>
        <HotkeysModal />
      </Fragment>
    )
  }
}
